import type { CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import type {
	FetchedSelectFilterOption,
	SelectFilterState,
} from '../../../../../common/constants/filters/select-filter/types';
import { ProductKeys } from '../../../../../common/constants/products';
import { Sort } from '../../../../../common/constants/schemas/query-params';
import { createSingleSelectFilter } from '../../../../filters/single-select-filter';

import { sortLabels } from './messages';

const SORT_VALUES = ['updatedNewest', 'updatedOldest', 'createdNewest', 'createdOldest'] as const;

const sortCompareFn = (a: FetchedSelectFilterOption, b: FetchedSelectFilterOption) => {
	return (
		(SORT_VALUES as readonly string[]).indexOf(a.queryParamValue) -
		(SORT_VALUES as readonly string[]).indexOf(b.queryParamValue)
	);
};

const products = [ProductKeys.Confluence, ProductKeys.Jira];

export const filter: Readonly<{
	id: 'sort';
	type: 'single-select' | 'multi-select';
	queryParams: {
		key: string;
		getState: (queryParams: Record<string, string[]>, cloudId: string) => SelectFilterState<'sort'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (
		state: unknown,
		config: CloudConfig,
	) => import('../../../../../common/constants/filters/select-filter/types').SelectFilterMonad<'sort'>;
	getInitialState: (
		config: CloudConfig,
	) => import('../../../../../common/constants/filters/select-filter/types').SelectFilterMonad<'sort'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createSingleSelectFilter({
	id: 'sort',
	products,
	alwaysVisible: true,
	universal: false,
	queryParams: {
		key: 'sort',
		fetcher: async (_, config) => {
			return SORT_VALUES.map((value) => ({
				trackingKey: value,
				label: config.intl?.formatMessage(sortLabels[value]) || sortLabels[value].defaultMessage,
				value,
				queryParamValue: value,
				product: config.product,
			}));
		},
	},
	initialOptions: {
		fetcher: async (config: CloudConfig) => {
			return [
				{
					trackingKey: Sort.Relevance,
					label:
						config.intl?.formatMessage(sortLabels[Sort.Relevance]) ||
						sortLabels[Sort.Relevance].defaultMessage,
					value: Sort.Relevance,
					isDefault: true,
					queryParamValue: Sort.Relevance,
					product: config.product,
				},
				...SORT_VALUES.map((value) => ({
					trackingKey: value,
					label: config.intl?.formatMessage(sortLabels[value]) || sortLabels[value].defaultMessage,
					value,
					queryParamValue: value,
					product: config.product,
				})),
			];
		},
	},
	sortCompareFn,
});
